/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMonitorData = (props: Props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <g fill="none">
      <path
        d="M2 2.15h20v10.047a7.382 7.382 0 0 0-2-.493V4.15H4v8h1.446l3.007-4.811 3.635 5.192 3.43-3.92 2.571 3.084c-.76.076-1.503.25-2.16.532l-.447-.537-3.57 4.079-3.365-4.808-1.993 3.189H4v6h9.5v.667c0 .507.12.954.299 1.333H2v-20z"
        fill="currentcolor"
      />
      <path
        d="M23 20.817c0 .51-.236.92-.511 1.208a2.99 2.99 0 0 1-.962.648c-.698.31-1.592.477-2.527.477s-1.83-.166-2.527-.477a3.003 3.003 0 0 1-.962-.648c-.274-.289-.511-.699-.511-1.208v-5.334c0-.51.236-.92.511-1.208a2.99 2.99 0 0 1 .962-.648c.698-.31 1.592-.477 2.527-.477s1.83.166 2.527.477c.348.154.692.364.962.648.274.289.511.699.511 1.208v5.334zm-2.285-5.363c-.387-.172-.993-.304-1.715-.304-.722 0-1.328.132-1.715.304l-.063.03.063.028c.387.173.993.305 1.715.305.722 0 1.328-.132 1.715-.305l.063-.029-.063-.029zM17 17.536v.48c.05.04.14.099.285.163.387.172.993.304 1.715.304.722 0 1.328-.132 1.715-.304a1.32 1.32 0 0 0 .285-.164v-.479a6.89 6.89 0 0 1-2 .28 6.89 6.89 0 0 1-2-.28zm0 3.146c.05.04.14.1.285.164.387.172.993.304 1.715.304.722 0 1.328-.132 1.715-.304.144-.064.234-.123.285-.164v-.48a6.894 6.894 0 0 1-2 .281 6.894 6.894 0 0 1-2-.28v.479z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMonitorData as MonitorData };
